import React from 'react'
import FloatingNav from './FloatingNav'
import Header from './Header'
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Sidebar from "./Sidebar";
import RightSidebar from "./RightSidebar";
export default function Wrapper(props) {
  const userData = useSelector((state) => state.account.userData);
  const location = useLocation();
  return (
    <div className="prevent-select">
      {location.pathname != "/login" && <Header />}
      <div
        _ngcontent-ng-c1893399002=""
        className="d-flex app-body adjust-height"
      >
        <Sidebar />
        <div _ngcontent-ng-c1893399002="" className="content">
          {props.children}
        </div>
        <RightSidebar />
      </div>
      {location.pathname != "/login" && <FloatingNav />}
    </div>
  );
}
